import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    address,
    email,
    fax,
    firstTime,
    phone,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxpayerName,
    address2,
    agencyContract,
    agencyContractDate,
    district,
    district2,
    organizationPayingName,
    province,
    province2,
    taxId1,
    taxId2,
    certificate,
    signer,
    fullName,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [address.name]: Yup.string().required(address.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [district2.name]: Yup.string().required(district2.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [province2.name]: Yup.string().required(province2.errorMsg),
  [organizationPayingName.name]: Yup.string().required(organizationPayingName.errorMsg),
  [agencyContract.name]: Yup.string().optional(),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [email.name]: Yup.string().required(certificate.errorMsg).email(email.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [agencyContractDate.name]: Yup.number().optional(),
});

export default validation;
